import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { SpApiRegion } from "./initSpApiOAuth";

interface ExchangeParams {
  /** The authorization code from Amazon SP-API OAuth callback */
  spapi_oauth_code: string;
  /** The selling partner ID from the callback */
  selling_partner_id: string;
  /** The Amazon region (NA, EU, FE) */
  region: SpApiRegion;
}

/**
 * Hook for exchanging Amazon SP-API OAuth authorization code for access tokens.
 * Uses TanStack Query mutation for handling the async POST request.
 *
 * The backend exchanges the code with Amazon, stores the tokens, and updates onboarding status.
 */
export function useSpApiOAuthExchange() {
  return useMutation({
    mutationFn: async ({ spapi_oauth_code, selling_partner_id, region }: ExchangeParams) => {
      return await apiClient.exchangeSpApiCode({ spapi_oauth_code, selling_partner_id, region });
    },
  });
}
